module.exports = __webpack_public_path__ + "img/lentes.9d8b60da.svg";